<template>
  <div class="outer-wrapper">
    <div class="inner-wrapper" v-show="currentShow==='menu'">
      <van-cell-group>
        <p slot="title" class="ac-title">您好，{{user.name}}</p>
        <van-cell title="个人信息" value="详情" is-link @click="goTab('pInfo')"/>
        <van-cell title="业绩积分" value="功能未开通" is-link />
        <van-cell title="我的申请" value="功能未开通" is-link />
        <van-cell title="密码修改" value is-link @click="goTab('pwdAlter')" />
        <van-cell title="电子签名" :value="signatureImg.imgUrl?'尚无':'更换'" is-link @click="goTab('sImg')"/>
      </van-cell-group>
      <div class="lo-wrapper">
        <van-cell-group>
          <van-cell>
            <p @click="logout" class="log-out">退出登录</p>
          </van-cell>
        </van-cell-group>
      </div>
    </div>

    <div class="tab-wrapper" v-show="currentShow==='pwdAlter'">
      <van-nav-bar title="修改密码" left-text="返回" left-arrow @click-left="onClickBack" fixed />
      <div class="bar-detail">
        <van-field
          :type="pwt.old"
          v-model="password.old"
          autocomplete="new-password"
          label="旧密码"
          placeholder="请输入原密码"
          required
          clearable
          :error="error.password.old"
          @focus="clearError"
        />
        <van-field
          :type="pwt.new1"
          v-model="password.new1"
          autocomplete="new-password"
          label="新密码"
          placeholder="请输入新密码"
          required
          clearable
          :error="error.password.new1"
          @focus="clearError"
        />
        <van-field
          :type="pwt.new2"
          v-model="password.new2"
          autocomplete="new-password"
          label="新密码"
          placeholder="请再次输入新密码"
          required
          clearable
          :error="error.password.new2"
          @focus="clearError"
        />
      </div>
      <div class="button-wrapper">
        <van-button color="#ee0a24" class="submit" @click="pwdAlterSubmit">确定修改</van-button>
        <van-button
          color="#ee0a24"
          class="submit"
          plain
          style="margin-left:1rem;"
          @click="onClickBack"
        >取消</van-button>
      </div>
    </div>

    <div class="tab-wrapper" v-show="currentShow==='pInfo'">
      <van-nav-bar title="修改个人信息" left-text="返回" left-arrow @click-left="onClickBack" fixed />
      <div class="bar-detail">
        <van-cell title="账号" :value="user.account" />
        <van-cell title="真实姓名" :value="user.name" />
        <van-cell title="电子邮箱" :value="user.email" is-link @click="goTab('emailAlter')"/>
        <van-cell title="账户状态" :value="user.stat" />
        <van-cell title="注册时间" :value="user.reg_time" />
        <van-panel title="担任职务" desc="系统管理员可进行职务更改" status="">
          <div class="role-wrapper"><span class="info-span role-span" v-for="r in user.role" :key="r.id">{{r.name}}</span></div>
        </van-panel>
      </div>
    </div>

    <div class="tab-wrapper" v-show="currentShow==='emailAlter'">
      <van-nav-bar title="修改电子邮箱" left-text="返回" left-arrow @click-left="onClickBackSpecial('pInfo')" fixed />
      <div class="bar-detail">
        <van-field
          type="text"
          v-model="userNew.email"
          label="新电子邮箱"
          placeholder="请输入新电子邮箱地址"
          clearable
          :error="error.userNew.email"
          @focus="clearError"
        />
      </div>
      <div class="button-wrapper">
        <van-button color="#ee0a24" class="submit" @click="emailAlterSubmit">确定修改</van-button>
        <van-button
          color="#ee0a24"
          class="submit"
          plain
          style="margin-left:1rem;"
          @click="onClickBack"
        >取消</van-button>
      </div>
    </div>

    <div class="tab-wrapper" v-show="currentShow==='sImg'">
      <van-nav-bar title="电子签名" left-text="返回" left-arrow @click-left="onClickBack" fixed />
      <div class="tv-wrapper">
        <van-panel title="当前使用签名" desc="签名图片主要用于报告署名" status="">
          <div class="img-upload-wrapper">
            <div class="img-area">
            <img style="width:100%;height:100%;" :src="signatureImgCurrent.imgUrl" v-show="signatureImgCurrent.imgUrl"/>
            <p v-show="!signatureImgCurrent.imgUrl">暂无</p>
          </div>
          </div>
        </van-panel>
        <van-panel title="更换新签名图片" desc="点击上传新的的签名图片" status="">
          <div class="img-upload-wrapper">
            <van-uploader 
          :after-read="handleBeforeUpload"
          :max-size="1024*100"
          :max-count="1"
          deletable
          >
          <div class="img-area">
            <img style="width:100%;height:100%;" :src="signatureImg.imgUrl" v-show="signatureImg.imgUrl"/>
            <p v-show="!signatureImg.imgUrl">点击上传</p>
          </div>
        </van-uploader>
          </div>
        </van-panel>       
      </div>
      <div class="button-wrapper">
        <van-button color="#ee0a24" class="submit" @click="sImgAlterSubmit">确定修改</van-button>
        <van-button
          color="#ee0a24"
          class="submit"
          plain
          style="margin-left:1rem;"
          @click="onClickBack"
        >取消</van-button>
      </div>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

function errorFac() {
  return {
    password: {
      old: false,
      new1: false,
      new2: false
    },
    userNew:{
      email:false,
    }
  };
}
export default {
  name: "accountCenter",
  data() {
    return {
      currentShow: "menu",
      error: errorFac(),
      profile: process.env.BASE_URL + "img/profile-pic.png",
      user: {
        account:"",
        name: "",
        email: "",
        stat: "",
        reg_time: "",
        role: []
      },
      userNew:{
        email:"",
        name:""
      },
      userOld: {
        name: "",
        email: "",
        stat: "",
        reg_time: "",
        role: []
      },
      password: {
        old: "",
        new1: "",
        new2: ""
      },
      iSettingsShowModal: false,
      statList: [],
      signatureImg: {
        imgObj: null,
        imgUrl: ""
      },
      signatureImgCurrent: {
        imgObj: null,
        imgUrl: ""
      }
    };
  },
  created(){
    this.get_data();

  },
  methods: {
    get_data() {
      this.$axios
        .post(this.$url + "/get_my_info", {
          userToken: userToken,
          askData: "base_info"
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.user.account = response.data.info.account;
            this.user.name = response.data.info.full_name;
            this.userNew.name = response.data.info.full_name;
            this.user.email = response.data.info.email;
            this.user.stat = response.data.info.stat;
            this.user.reg_time = response.data.info.reg_time;
            this.user.role = JSON.parse(response.data.info.role);
            this.userOld = JSON.parse(JSON.stringify(this.user));
            this.signatureImgCurrent.imgUrl = this.$fileUrlFac(
              response.data.info.signature_url,authData.sfileRight
            );
          } else {
            this.$toast.fail("错误操作！");
          }
        })
        .catch(error => {
          this.$toast.fail(error + "或网络连接失败！");
        });
    },
    onClickBack() {
      this.currentShow = 'menu';
    },
    onClickBackSpecial(val){
      this.currentShow = val;
    },
    goTab(val) {
      this.currentShow = val;
    },
    clearError() {
      this.error = errorFac();
    },
    checkPassword() {
      if (!this.password.old.trim()) {
        this.error.password.old = true;
        return false;
      } else if (!this.password.new1.trim()) {
        this.error.password.new1 = true;
        return false;
      } else if (!this.password.new2.trim()) {
        this.error.password.new2 = true;
        return false;
      } else if (!/^[\da-zA-Z_]{6,18}$/.test(this.password.new1)) {
        this.error.password.new1 = true;
        this.password.new1 = "";
        this.password.new2 = "";
        this.$toast(
          "新密码不符合要求，要求6~18位数字大小写字母或下划线，请重新设置！"
        );
        return false;
      } else if (this.password.new1 != this.password.new2) {
        this.error.password.new1 = true;
        this.error.password.new2 = true;
        this.password.new1 = "";
        this.password.new2 = "";
        this.$toast("两次新密码不同，请重新设置！");
        return false;
      } else {
        return true;
      }
    },
    checkEmail(){
      if (!this.userNew.email.trim()) {
        this.error.userNew.email = true;
        return false;
      }else if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.userNew.email)) {
        this.error.userNew.email = true;
        this.$toast(
          "邮箱格式错误，请输入正确的电子邮箱！"
        );
        return false;
      }else{
        return true;
      } 
    },
    pwdAlterSubmit() {
      if (this.checkPassword()) {
        this.$axios
          .post(this.$url + "/alter_password", {
            userToken: userToken,
            val: this.password
          })
          .then(response => {
            if (response.data.stat === "ok") {
              this.$toast.success("修改密码成功！");
              this.password.old = "";
              this.password.new1 = "";
              this.password.new2 = "";
              this.onClickBack();
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch(error => {
            this.$toast.fail(error + "未知错误！");
          });
      }
    },
    emailAlterSubmit(){
      if (this.checkEmail()) {
        this.$axios
          .post(this.$url + "/account_modify", {
            userToken: userToken,
            val: this.userNew
          })
          .then(response => {
            if (response.data.stat === "ok") {
              this.user.email = this.userNew.email;
              this.$toast.success("修改邮箱地址成功！");
              this.onClickBackSpecial('pInfo');
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch(error => {
            this.$toast.fail(error + "网络连接异常！");
          });
      }
    },
    sImgAlterSubmit(){
      if (this.signatureImg.imgObj) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("signatureImg", this.signatureImg.imgObj);
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/alter_signature_img", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.signatureImgCurrent.imgUrl = this.$fileUrlFac(
              response.data.signature_url,authData.sfileRight
            );
            this.signatureImg.imgUrl = "";
            this.signatureImg.imgObj = null;
              this.$toast.success("签名图片修改成功！");
            } else {
              this.$toast.fail('操作错误');
            }
          })
          .catch(error => {
            this.$toast.fail(error + "网络连接错误！");
          });
      }else{
        this.$toast.info('未选择图片！');
      }
    },    
    logout: function() {
      localStorage.clear();
      this.logined = false;
      location.href = "/login";
    },
    /*modal_save() {
      if (JSON.stringify(this.user) !== JSON.stringify(this.userOld)) {
        this.$axios
          .post(this.$url + "/account_modify", {
            userToken: userToken,
            val: this.user
          })
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("修改个人信息成功！");
            } else {
              this.$Message.error(response.data.error_info);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
      }
      if (
        this.password.old !== "" &&
        this.password.new1 === this.password.new2 &&
        this.password.new1 !== ""
      ) {
        if (this.password.new1.length < 6 || this.password.new1.length > 19) {
          this.$Message.error("新密码长度应大于6且小于19！");
        } else {
          this.$axios
            .post(this.$url + "/alter_password", {
              userToken: userToken,
              val: this.password
            })
            .then(response => {
              if (response.data.stat === "ok") {
                this.$Message.success("修改密码成功！");
                this.password.old = "";
                this.password.new1 = "";
                this.password.new2 = "";
              } else {
                this.$Message.error(response.data.error_info);
              }
            })
            .catch(error => {
              this.$Message.error(error + "未知错误！");
            });
        }
      }
      if (this.signatureImg.imgUrl !== this.signatureImgOld.imgUrl) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("signatureImg", this.signatureImg.imgObj);
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/alter_signature_img", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("签名图片修改成功！");
            } else {
              this.$Message.error(response.data);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },*/
    handleBeforeUpload(img) {
      this.signatureImg.imgObj = img.file;
      this.signatureImg.imgUrl = img.content;
    }
  },
  watch: {},
  computed: {
    pwt: function() {
      return {
        old: this.password.old ? "password" : "text",
        new1: this.password.new1 ? "password" : "text",
        new2: this.password.new2 ? "password" : "text"
      };
    }
  }
};
</script>
<style scoped>
.outer-wrapper {
  width: 100%;
}
.lo-wrapper {
  background: #f7f7f7;
  border: 1px solid #f7f7f7;
  padding: 3rem 0;
}

.log-out {
  text-align: center;
  font-weight: 600;
  background: #fff;
}
.ac-title {
  text-align: center;
  background: #fff;
  font-weight: 500;
  color: #666;
  padding-bottom: 1rem;
}

.tab-wrapper {
  padding: 1rem 0;
}

.button-wrapper {
  padding: 2rem;
  text-align: center;
}

.submit {
  width: 5rem;
}

.role-wrapper{
  padding: 0.5rem 1rem;

}
.role-span{
  border:1px dashed #999;
  font-size:0.6rem;
  padding: 0.1rem 0.3rem;
}

.img-upload-wrapper{
  text-align: center;
  margin:1rem 0;
  padding-bottom:1rem; 
}

.img-area{
  width:8.8rem;
  height:3.3rem;
  border:1px dashed #eee;
  margin:0 auto;
}

.img-area p{
  color:#ddd;
  font-size:0.6rem;
  text-align: center;
  line-height: 3.3rem;
}
</style>

